<template>
  <div class="warranty">
    <div :class="['warranty__content', { 'with-error': warrantyError }]">
      <div class="top-content">
        <div class="text-wrap">
          <h2 class="title">12 Monate kostenloses PKW.de-Schutzpaket</h2>
          <p v-if="manufactorWarranty.warranty_still_valid">
            Ihr Fahrzeug hat noch <b>{{ manufactorWarranty.warranted_months_left }} Monate Herstellergarantie</b>. Die kostenlose PKW.de-Garantie läuft 12 Monate ab Ende der Herstellergarantie.
          </p>
          <p v-else>Die kostenlose PKW.de-Garantie läuft 12 Monate ab Ende der Hersteller-Garantie.</p>
        </div>
        <div class="shield">
          <div class="shield-content">
            <p class="shield-title">Unser Versprechen</p>
            <p>{{ fullWarrantyTerm }} Monate Schutz - garantiert!</p>
          </div>
        </div>
      </div>
      <form>
        <div class="top-item">
          <div
            :class="['radio-form-item', { active: warranty === 'basic' }]"
            @click="() => handleCheckboxChange('basic')"
          >
            <input :checked="warranty === 'basic'" type="radio" />
            <div class="radio-form-item__top-content">
              <div class="price-wrap">
                <h4>PKW.de-Basic-Schutz</h4>
                <p class="radio-form-item__price">€ 0 ,-</p>
              </div>
              <div class="list-wrap">
                <ul class="check-list">
                  <li>Motor</li>
                  <li>Getriebe/Differential</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="options">
          <h3>Garantie-Upgrade</h3>
          <div class="additional-plans">
            <div>
              <div
                :class="['radio-form-item', { active: warranty === 'classic' }]"
                @click="() => handleCheckboxChange('classic')"
              >
                <input :checked="warranty === 'classic'" type="radio" />
                <div class="radio-form-item__top-content">
                  <div>
                    <h4>Klassik-Schutz</h4>
                    <p class="radio-form-item__price">€ 150 ,- <span class="mwst block">inkl. Mwst.</span></p>
                  </div>
                </div>
              </div>
              <div
                :class="['radio-form-item premium-option recommendation', { active: warranty === 'premium' }]"
                @click="() => handleCheckboxChange('premium')"
              >
                <input :checked="warranty === 'premium'" type="radio" />
                <div class="radio-form-item__top-content">
                  <div>
                    <h4>Premium-Schutz</h4>
                    <p class="radio-form-item__price">€ 270 ,- <span class="mwst block">inkl. Mwst.</span></p>
                  </div>
                </div>
              </div>
              <div
                :class="['radio-form-item', { active: warranty === 'premium_plus' }]"
                @click="() => handleCheckboxChange('premium_plus')"
              >
                <input :checked="warranty === 'premium_plus'" type="radio" />
                <div class="radio-form-item__top-content">
                  <div>
                    <h4>Premium-Plus-Schutz</h4>
                    <p class="radio-form-item__price">€ 680 ,- <span class="mwst block">inkl. Mwst.</span></p>
                  </div>
                </div>
              </div>
              <button class="warranty-btn desktop" type="button" @click="openModal">Garantietarife im Vergleich</button>
            </div>
            <div :class="['warranty-details', warrantyInfo.className]">
              <h4>{{ warrantyInfo.name }}</h4>
              <template v-if="warranty !== 'basic'">
                <h6>Abdeckung</h6>
                <ul class="check-list">
                  <li>Motor</li>
                  <li>Getriebe/Differential</li>
                  <li>Lenkung</li>
                  <li>Bremssystem</li>
                  <li>Kühlsystem</li>
                  <li class="inactive">Heizung und Klimaanlage</li>
                  <li class="inactive">Gemischaufbereitung</li>
                  <li class="inactive">Elektrik</li>
                  <li class="inactive">Komfortelektrik</li>
                  <li class="inactive">Kraftübertragung</li>
                  <li class="inactive">Abgasanlage</li>
                  <li class="inactive">Sicherheitssysteme</li>
                  <li class="inactive">Motoraufladung</li>
                  <li class="inactive inactive-premium">Niveauregulierung</li>
                </ul>
                <h6>Zeitraum der Garantie</h6>
                <p>12 Monate ab Lieferdatum</p>
                <h6>Einmalige Kosten: € {{ warrantyInfo.price }} ,- <span class="mwst">inkl. Mwst.</span></h6>
                <p>Keine automatische Vertragsverlängerung</p>
              </template>
              <p v-else>Auf Wunsch können Sie ein Garantie-Upgrade auswählen</p>
            </div>
            <button class="warranty-btn mobile" type="button" @click="openModal">Garantietarife im Vergleich</button>
          </div>
        </div>

        <p v-if="warrantyError" class="error">Bitte Option wählen.</p>
      </form>
    </div>
<!--    <div :class="['warranty__insuarance', { 'with-error': insuranceError }]">-->
<!--      <h2 class="title">Autoversicherung</h2>-->
<!--      <form>-->
<!--        <div class="radio-form-item" @click="() => handleInsuranceCheckboxChange(true)">-->
<!--          <input :checked="insurance === true" type="radio" />-->
<!--          <div class="radio-form-item__top-content">-->
<!--            <div>-->
<!--              <h4>-->
<!--                <b>Ja,</b> ich bin an einem unverbindlichen Angebot für eine Autoversicherung interessiert.-->
<!--              </h4>-->
<!--            </div>-->
<!--            <p>-->
<!--              <b>FRIDAY Original:</b> Zum Preis-Leistungs-Sieger ab 7,49 Euro pro Monat-->
<!--            </p>-->
<!--            <ul class="check-list">-->
<!--              <li>Einfach und günstig</li>-->
<!--              <li>Von Auto Zeitung als Preis-Leistungs-Sieger ausgezeichnet</li>-->
<!--              <li>Monatlich kündbar</li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="radio-form-item" @click="() => handleInsuranceCheckboxChange(false)">-->
<!--          <input :checked="insurance === false" type="radio" />-->
<!--          <div class="radio-form-item__top-content">-->
<!--            <div>-->
<!--              <h4><b>Nein,</b> ich möchte kein Angebot zur Autoversicherung erhalten.</h4>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <p v-if="insuranceError" class="error">Bitte Option wählen.</p>-->
<!--      </form>-->
<!--    </div>-->
    <div class="btns">
      <button class="btn" type="button" @click="updateOrderData">{{ editMode ? 'Änderungen übernehmen' : 'Nächster Schritt'}}</button>
    </div>
    <WarrantyModal :is-open="showModal" @close="closeModal" />
  </div>
</template>

<script>
import WarrantyModal from '@/components/modals/WarrantyModal';

const packages = {
  basic: { name: 'Garantie-Upgrade', className: 'basic', price: '' },
  classic: { name: 'Klassik-Schutz', className: 'classic', price: '150' },
  premium: { name: 'Premium-Schutz', className: 'premium', price: '270' },
  premium_plus: { name: 'Premium-Plus-Schutz', className: 'premium-plus', price: '680' },
};

export default {
  components: {
    WarrantyModal,
  },
  props: ['order', 'editMode'],
  data() {
    return {
      warranty: this.order.warranty_extension || 'basic',
      warrantyError: false,
      insurance: this.order.car_insurance !== undefined ? this.order.car_insurance : false,
      insuranceError: false,
      showModal: false,
    };
  },
  computed: {
    warrantyInfo() {
      return packages[this.warranty];
    },
    manufactorWarranty() {
      const carInfo = this.order.car_info;
      const noManufactorWarranty = {
        warranted_months: 0,
        warranted_months_left: 0,
        warranted_milage: 0,
        warranty_still_valid: false,
      };
      return carInfo.manufacturer_warranty ? carInfo.manufacturer_warranty : noManufactorWarranty;
    },
    fullWarrantyTerm() {
      return this.manufactorWarranty.warranty_still_valid ? this.manufactorWarranty.warranted_months_left + 12 : 12;
    },
  },
  watch: {
    warranty(val) {
      if (val && this.warrantyError) {
        this.warrantyError = false;
      }
    },
    insurance(val) {
      if (val && this.insuranceError) {
        this.insuranceError = false;
      }
    },
  },
  methods: {
    updateOrderData(e) {
      e.preventDefault();
      const isValid = this.validateForm();
      if (isValid) {
        this.sending = true;
        const params = {
          warranty_service: this.warranty,
          car_insurance: this.insurance,
        };
        this.$emit('updateOrderStep', this.order.token, params);
        this.trackEvent(this.warranty);
      }
    },
    validateForm() {
      let noError = true;
      if (this.warranty === '') {
        this.warrantyError = true;
        noError = false;
      } else {
        this.warrantyError = false;
      }
      // if (this.insurance === '') {
      //   this.insuranceError = true;
      //   noError = false;
      // } else {
      //   this.insuranceError = false;
      // }
      if (noError) {
        this.warrantyError = false;
        // this.insuranceError = false;
      }
      return noError;
    },
    trackEvent(warranty) {      
      window.dataLayer.push({
        event: 'selected_warranty',
        warranty_product: warranty
      });

      console.log('Tracked selected warranty:', warranty);
    },
    handleCheckboxChange(value) {
      if (this.warranty === value) {
        this.warranty = 'basic';
      } else {
        this.warranty = value;
      }
    },
    handleInsuranceCheckboxChange(value) {
      this.insurance = value;
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss">
.mwst {
  font-size: 12px;
  font-weight: normal;
  white-space: nowrap;
}
.block {
  display: block;
}
.warranty {
  padding: 30px 0.625rem;
  &__content {
    .warranty-details {
      position: relative;
      padding: 20px;
      border: 1px solid #d6d6d6;
      line-height: 26px;
      margin-bottom: 20px;
      &.classic {
        .inactive:before {
          content: '\f00d';
          color: $red;
        }
      }
      &.premium {
        .inactive-premium:before {
          content: '\f00d';
          color: $red;
        }
      }
      &.basic {
        > p {
          margin-top: 20px;
        }
      }
      @include breakpoint(desktop) {
        padding: 25px 30px;
      }
      h4 {
        border-bottom: 1px solid #d8d8d8;
        padding-bottom: 15px;
      }
      h6 {
        margin-top: 20px;
        font-size: 16px;
        font-weight: 700;
      }
      ul {
        li {
          margin-left: 0;
        }
      }
    }
    .options {
      .additional-plans {
        @include breakpoint(desktop) {
          display: flex;
          > div {
            width: 50%;
          }
          .warranty-details {
            margin-left: 15px;
          }
        }
      }
      .warranty-btn {
        width: 100%;
        border: 1px solid $red;
        border-radius: 25px;
        line-height: 50px;
        font-size: 14px;
        font-weight: 700;
        color: $red;
        &.desktop {
          display: none;
          @include breakpoint(desktop) {
            display: block;
          }
        }
        &.mobile {
          @include breakpoint(desktop) {
            display: none;
          }
        }
      }
      > h3 {
        margin-bottom: 20px;
      }
      .radio-form-item {
        margin-bottom: 20px;
      }
    }
  }
  .top-item {
    margin-bottom: 45px;
    @include breakpoint(desktop) {
      .radio-form-item__top-content {
        display: flex;
        align-items: center;
        .list-wrap {
          margin: 0 0 0 40px;
        }
      }
      .radio-form-item input[type='radio'] {
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .list-wrap {
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      h3 {
        font-size: 16px;
      }
      .check-list {
        margin-top: 10px;
        li {
          margin-left: 0;
        }
      }
    }
  }
  .top-content {
    display: flex;
    flex-direction: column;
    @include breakpoint(desktop) {
      align-items: center;
      flex-direction: row;
      margin-bottom: 30px;
    }
    .text-wrap {
      @include breakpoint(desktop) {
        flex: 3;
        margin-right: 30px;
        p {
          font-size: 18px;
        }
      }
      p {
        line-height: 30px;
      }
    }
  }
  .shield {
    position: relative;
    height: 170px;
    margin: 20px auto;
    font-size: 16px;
    text-align: center;
    @include breakpoint(desktop) {
      flex: 1;
    }
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 42px;
      width: 145px;
      height: 100%;
      background-color: $white;
      background: url('../assets/images/shield-bg.svg') no-repeat;
      background-size: contain;
    }
    &-content {
      position: relative;
      width: 230px;
      padding: 10px 0;
      margin-top: 50px;
      background-color: $white;
      z-index: 2;
    }
    &-title {
      font-size: 18px;
      font-weight: 700;
    }
  }
  .warranty__insuarance {
    margin-top: 20px;
    .radio-form-item__top-content {
      > p {
        margin-left: 10px;
        margin-top: 10px;
      }
      > div {
        flex-direction: column;
        @include breakpoint(desktop) {
          flex-direction: row;
          .radio-form-item__bell {
            width: 250px;
          }
        }
        h4 {
          font-weight: 400;
        }
        &.no-tires {
          flex-direction: column;
          &.with-error {
            .error {
              margin-left: 0;
              padding: 5px 0;
              font-size: 12px;
              line-height: 12px;
              color: $red;
            }
            input[type='checkbox'] + label:before {
              border-color: $red;
            }
          }
          .financed-plan-form__checkbox {
            margin: 30px 0;
            .custom-checkbox {
              input[type="checkbox"]:checked + label:after {
                top: 0;
              }
            }
            > div {
              display: flex;
              align-items: center;
              color: $red;
              > p {
                font-size: 14px;
                margin-left: 30px;
              }
            }
          }
        }
      }
    }
  }

  @include breakpoint(desktop) {
    padding: 0 0 30px;
  }

  .video {
    margin-top: 30px;
    max-width: 500px;
    h3 {
      margin-bottom: 20px;
      line-height: 30px;
    }
  }

  .warranty__note {
    padding: 10px;
    display: inline-block;
    margin-bottom: 20px;
  }

  .btns {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    .btn-red {
      margin-right: 10px;
      font-weight: 400;
      border: 1px solid $red;
      background-color: transparent;
      color: $red;
    }
  }
  .radio-form-item {
    margin-bottom: 10px;
    &__main-content {
      margin: 20px 0 30px;
      button {
        color: $red;
      }
    }
    &__bell {
      margin: 10px 0 0 30px;
      font-size: 14px;
      font-weight: 700;
      color: $red;
      i {
        margin-right: 5px;
      }
    }
  }
  .check-list {
    margin-top: 20px;
  }
  .btn {
    margin-top: 10px;
  }
  .with-error {
    .radio-form-item {
      border-color: $red;
    }
    .title {
      color: $red;
    }
    .error {
      font-size: 12px;
      line-height: 24px;
      color: $red;
    }
  }
  .check-list button {
    padding: 0;
  }
  @include breakpoint(medium) {
    .btns {
      flex-direction: row;
    }
  }
  @include breakpoint(desktop) {
    .radio-form-item {
      &__main-content {
        display: flex;
        padding-left: 30px;
        > * {
          flex: 1;
        }
      }
    }
    &__note {
      padding-left: 30px;
    }
  }
}
</style>
